<template>
    <div class="animated fadeIn">
        <DynamicForm
                v-model="dataId"
                ref="dynamicForm"
                getRoot="/recurring-subscription"
                saveRoot="/recurring-subscription"
                @onTrashClick="onTrashClick"
                @onInit="onInit"
                :saveAddArgs="saveAddArgs"
                @onRequestSuccess="onRequestSuccess"
                @onInitSuccess="onInitSuccess"
                @onSaveSuccess="onSaveSuccess"
                :formStructure="dataFormStructures.recurringSubscription">
            <slot slot="ccDefault">
                <CCDefault ref="ccDefault" v-model="dataCCDefault" :displaySelectSaved="Core.Validation.isId(dataUserId)" :entityId="dataUserId" entityType="user"></CCDefault>
            </slot>
            <slot slot="beforeFormButtons">
                <b-button v-if="Core.Validation.isId(dataId)" @click="modelInvoiceOnClick" class="btn btn-light mr-2"><i class="fa fa-file-text mr-2"></i>{{Core.Definition.getDefinition('Facture')}}</b-button>
                <ModalInvoice ref="modalInvoice"></ModalInvoice>
            </slot>
        </DynamicForm>
        <ModalTrash
                ref="trash"
                root="/recurring-subscription"
                @onTrashSuccess="onTrashSuccess"
                :caption="Core.Definition.getDefinition('Suppression de l\'abon. récurrent')"
                :message="Core.Definition.getDefinition('Êtes-vous sûr de vouloir supprimer cet abon. récurrent?')"></ModalTrash>
    </div>
</template>

<script>
    var _self;
    import DynamicForm from '../../components/DynamicForm'
    import ModalTrash from '../../components/ModalTrash'
    import CCDefault from '../../components/CCDefault'
    import ModalInvoice from '../../components/ModalInvoice'
    export default {
        name: 'RecurringSubscription',
        components: {
            DynamicForm,
            ModalTrash,
            CCDefault,
            ModalInvoice
        },
        mounted() {
            _self = this
        },
        data: function () {
            return {
                Core: window.Core,
                Mantle: window.Mantle,
                dataId: '',
                dataUserId: '',
                dataCCDefault: {
                    id: ''
                },
                dataFormStructures: {
                    recurringSubscription: {
                        rows: [
                            {
                                cols: [
                                    {
                                        class: 'card-columns',
                                        cards: [
                                            {
                                                caption: Core.Definition.getDefinition('Abonnement récurrent'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'status'
                                                                    }
                                                                ]
                                                            },
                                                            {}
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Client'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'userAction'
                                                                    },
                                                                    {
                                                                        id: 'userId'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingFirstname'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingLastname'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingEmail'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingPhone'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingAddress'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCountry'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingProvince'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingCity'
                                                                    }
                                                                ]
                                                            },
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'billingZipcode'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Notes'),
                                                rows: [
                                                    {
                                                        cols: [
                                                            {
                                                                fields: [
                                                                    {
                                                                        id: 'notes'
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    }
                                                ]
                                            },
                                            {
                                                caption: Core.Definition.getDefinition('Moyen de paiement'),
                                                key: 'ccDefault'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'productRecurringSubscriptionSummary',
                                                required: true
                                            }
                                        ]
                                    },
                                    {
                                        fields: [
                                            {
                                                id: 'bookingSummary'
                                            }
                                        ]
                                    }
                                ]
                            },
                            {
                                cols: [
                                    {
                                        fields: [
                                            {
                                                id: 'payments'
                                            }
                                        ]
                                    }
                                ]
                            }
                        ],
                        fields: [
                            {
                                id: 'status',
                                type: 'select',
                                label: Core.Definition.getDefinition('État'),
                                value: Core.Select.select(Mantle.Subscription.statusActivated, Mantle.Subscription.statusOptions()),
                                onSelect: function(value, form, fieldRefs) {}
                            },
                            {
                                id: 'billingFirstname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Prénom'),
                                value: ''
                            },
                            {
                                id: 'billingLastname',
                                type: 'text',
                                required: true,
                                label: Core.Definition.getDefinition('Nom de famille'),
                                value: ''
                            },
                            {
                                id: 'billingEmail',
                                type: 'email',
                                label: Core.Definition.getDefinition('Courriel'),
                                value: ''
                            },
                            {
                                id: 'billingPhone',
                                type: 'phone',
                                label: Core.Definition.getDefinition('Téléphone'),
                                value: ''
                            },
                            {
                                id: 'billingAddress',
                                type: 'text',
                                label: Core.Definition.getDefinition('Adresse'),
                            },
                            {
                                id: 'billingCountry',
                                type: 'country',
                                label: Core.Definition.getDefinition('Pays'),
                                required: false,
                                value: {value: 'CA', label :'Canada'},
                                onSelect: function(value, form, fieldRefs) {
                                    if (value !== null && value.value !== undefined) {
                                        fieldRefs['billingProvince'].retrieve(value.value)
                                    } else {
                                        fieldRefs['billingProvince'].dataValue = null
                                    }
                                }
                            },
                            {
                                id: 'billingProvince',
                                type: 'province',
                                value: {value: 'QC', label: 'Quebec'},
                                label: Core.Definition.getDefinition('Province'),
                                required: false
                            },
                            {
                                id: 'billingCity',
                                type: 'text',
                                label: Core.Definition.getDefinition('Ville'),
                            },
                            {
                                id: 'billingZipcode',
                                type: 'text',
                                label: Core.Definition.getDefinition('Code Postal'),
                            },
                            {
                                id: 'notes',
                                type: 'notes'
                            },
                            {
                                id: 'payments',
                                type: 'payments',
                                calcTotalOnEval: true,
                                displayFullCompletedPayment: true,
                                displayCompletedPayment: false,
                                options: {displayAddNewPayment: false},
                                instance: Core.Product.typeRecurringSubscription,
                                instanceId: 0,
                                total: 0,
                                forceTotal: true,
                                onTokenizationSuccess(payment) {
                                    _self.$refs.dynamicForm.addSaveArg('payment', JSON.stringify(payment))
                                    _self.$refs.dynamicForm.$refs.form.submit()
                                },
                                onPaymentCompleted(payment) {
                                    if (payment.method !== undefined) {
                                        switch(payment.method) {
                                            case Core.Payment.methodTerminal:
                                            case Core.Payment.methodCash:
                                                _self.$refs.dynamicForm.$refs.form.submit()
                                                break
                                        }
                                    }
                                },
                                onCheckPayment(){}
                            },
                            {
                                id: 'productRecurringSubscriptionSummary',
                                type: 'productRecurringSubscriptionSummary',
                                value:  {
                                    recurringSubscriptionProductId: '',
                                    title: '',
                                    shortDescription: '',
                                    productId: '',
                                    amount: '0',
                                    periodInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                                    period: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    periodLength: '0',
                                    periodPaymentLength: '0',
                                    bookingLimitManagement: false,
                                    bookingLimit: '0',
                                    bookingLimitPeriod: Core.Select.select(Core.Product.periodMonth, Core.Product.periodOptions()),
                                    bookingLimitInterval: Core.Select.select(Core.Product.periodIntervalOne, Core.Product.periodIntervalOptions()),
                                    start: null,
                                    end: null,
                                    isTaxable: true
                                },
                                onCheckPayment() {},
                                onEvalPayments: function(dates, value, form, fieldRefs) {
                                    let existingPaymentDates = fieldRefs['payments'].getPayments()
                                    fieldRefs['payments'].clearPayments()
                                    for(let date in dates) {
                                        date = dates[date]
                                        let existingDate = Core.Array.findByKey(existingPaymentDates, 'date', date)
                                        if (existingDate===false) {
                                            fieldRefs['payments'].addPayment(date, Core.Payment.statusWaiting, Core.Payment.methodCC, value.amount, '')
                                        } else {
                                            fieldRefs['payments'].addPayment(existingDate.date, existingDate.status, existingDate.method, existingDate.subTotal, '')
                                        }
                                    }
                                }
                            },
                            {
                                id: 'bookingSummary',
                                type: 'bookingSummary',
                                value: []
                            },
                            {
                                id: 'userId',
                                type: 'hidden',
                                value: ''
                            },
                            {
                                id: 'userAction',
                                type: 'userAction',
                                class: 'mb-3 pull-right',
                                updateUser: function(value, form, fieldRefs) {
                                    if (value.id === undefined) {
                                        value.id = ''
                                    }
                                    fieldRefs['userId'].dataValue = value.id

                                    _self.dataUserId = value.id

                                    if (value.firstname === undefined) {
                                        value.firstname = ''
                                    }
                                    fieldRefs['billingFirstname'].dataValue = value.firstname

                                    if (value.lastname === undefined) {
                                        value.lastname = ''
                                    }
                                    fieldRefs['billingLastname'].dataValue = value.lastname

                                    if (value.email === undefined) {
                                        value.email = ''
                                    }
                                    fieldRefs['billingEmail'].dataValue = value.email

                                    if (value.phone === undefined) {
                                        value.phone = ''
                                    }
                                    fieldRefs['billingPhone'].dataValue = value.phone

                                    if (value.billingAddress === undefined) {
                                        value.billingAddress = ''
                                    }
                                    fieldRefs['billingAddress'].dataValue = value.billingAddress

                                    if (value.billingCountry === undefined) {
                                        value.billingCountry = 'CA'
                                    }
                                    fieldRefs['billingCountry'].dataValue = Core.Select.select(value.billingCountry, fieldRefs['billingCountry'].getOptions())

                                    if (value.billingCity === undefined) {
                                        value.billingCity = ''
                                    }
                                    fieldRefs['billingCity'].dataValue = value.billingCity

                                    if (value.billingZipcode === undefined) {
                                        value.billingZipcode = ''
                                    }
                                    fieldRefs['billingZipcode'].dataValue = value.billingZipcode

                                }
                            }
                        ]
                    }
                }
            }
        },
        methods: {
            onInit(data) {
                if (Core.Validation.isId(this.$route.params.bookingId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initBookingId', this.$route.params.bookingId)
                }
                if (Core.Validation.isId(this.$route.params.userId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initUserId', this.$route.params.userId)
                    this.dataUserId = this.$route.params.userId
                }
                if (Core.Validation.isId(this.$route.params.productId)) {
                    this.$refs.dynamicForm.$refs.request.addArg('initProductId', this.$route.params.productId)
                }
            },
            onInitSuccess(data) {
                if (data.form !== undefined && data.form.billingEmail !== undefined) {
                    this.$refs.modalInvoice.email = data.form.billingEmail
                }
            },
            onRequestSuccess(data) {
                if (data.ccDefault) {
                    this.dataCCDefault = data.ccDefault
                }
                if (data.form !== undefined && data.form.userId !== undefined) {
                    this.dataUserId = data.form.userId
                }
            },
            saveAddArgs() {
                let userCreditCardId = 0
                if (this.dataCCDefault.id !== undefined) {
                    userCreditCardId = this.dataCCDefault.id
                }
                return [
                    {
                        key: 'userCreditCardId',
                        value: this.dataCCDefault.id,
                        type: Core.Value.typeInt
                    }
                ]
            },
            onTrashClick(id) {
                this.$refs.trash.open(id)
            },
            onTrashSuccess() {
                this.$router.push('/commerce/abonnements-recurrents')
            },
            onSaveSuccess() {
                this.$refs.dynamicForm.$refs.request.clearArgs()
                this.$refs.dynamicForm.clearSaveArgs()
            },
            modelInvoiceOnClick() {
                this.$refs.modalInvoice.instanceType = 'recurringSubscription'
                this.$refs.modalInvoice.instanceId = this.dataId
                this.$refs.modalInvoice.open = true
            }
        }
    }
</script>
